<template style='text-align:left'>

    <v-layout row >
      <v-flex xs12 mx-0>
        <div style='width:14em;float:left'>{{sp.service}}</div>
        <div style='width:19em;float:left' v-html='date()'/>
      </v-flex>
    </v-layout> 
</template>        

<script>
export default {

  components: { },
  props: {
    sp: null
  },

  data () {
    return {
    } 
  },

  methods: {
    date () {
      if (!this.sp.dateRange) return "<span class='lite'>undated&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>" ;
      return this.$dateFormatFromYMD(this.sp.dateRange).replace(/ /g, "&nbsp;") ;             
    }
  } 
}
</script>

<style>
.lite {color:#aaaaaa} ;
</style>



// WEBPACK FOOTER //
// src/components/Person/ShowServicePeriod.vue